const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Validates that a URL uses an allowed protocol (http/https only).
 * Prevents XSS attacks via javascript:, data:, and other dangerous protocols.
 *
 * @param url - The URL string to validate
 * @returns true if URL uses http/https protocol, false otherwise
 */
export function isAllowedUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ALLOWED_PROTOCOLS.has(parsed.protocol);
  } catch {
    return false; // Invalid URLs are rejected
  }
}
